var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5733H11.4933C10.96 12.5733 10.4533 12.78 10.08 13.1533L8.93998 14.28C8.41998 14.7933 7.57334 14.7933 7.05334 14.28L5.91333 13.1533C5.54 12.78 5.02667 12.5733 4.5 12.5733H4C2.89333 12.5733 2 11.6867 2 10.5933V3.31999C2 2.22666 2.89333 1.34001 4 1.34001H12C13.1067 1.34001 14 2.22666 14 3.31999V10.5933C14 11.68 13.1067 12.5733 12 12.5733Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 6.66666C8.858 6.66666 9.55347 5.9712 9.55347 5.11332C9.55347 4.25543 8.858 3.56001 8.00012 3.56001C7.14224 3.56001 6.44678 4.25543 6.44678 5.11332C6.44678 5.9712 7.14224 6.66666 8.00012 6.66666Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 10.44C10.6668 9.23998 9.4735 8.26668 8.00016 8.26668C6.52683 8.26668 5.3335 9.23998 5.3335 10.44",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTag);
export default __webpack_public_path__ + "static/media/userTag.64cfd0ea0067e4dd0238b866265b2eab.svg";
export { ForwardRef as ReactComponent };